import React from 'react';
import Icon from '../Icon/Icon';
import styles from './DecoratedHeader.module.css';

interface DecoratedHeaderProps {
  title: string;
  showBackButton?: boolean;
  backButtonSize?: number;
  onBackPress?: () => void;
  className?: string;
  preserveLineBreaks?: boolean;
}

const DecoratedHeader: React.FC<DecoratedHeaderProps> = ({
  title,
  showBackButton = false,
  backButtonSize = 40,
  onBackPress,
  className = '',
  preserveLineBreaks = false,
}) => {
  const showBack = Boolean(showBackButton && onBackPress);
  const rootClassName = [styles.root, className].filter(Boolean).join(' ');
  const titleRowClassName = [styles.titleRow, showBack ? styles.titleRowWithBack : '']
    .filter(Boolean)
    .join(' ');
  const titleClassName = [styles.title, preserveLineBreaks ? styles.titleMultiline : '']
    .filter(Boolean)
    .join(' ');
  const titleText = preserveLineBreaks
    ? title.trim()
    : title.replace(/\s*\n+\s*/g, ' ').trim();
  return (
    <div className={rootClassName}>
      <div className={titleRowClassName}>
        {showBack ? (
          <button
            type="button"
            className={styles.backButton}
            style={{ width: backButtonSize, height: backButtonSize }}
            onClick={onBackPress}
            aria-label="Voltar"
          >
            <Icon name="arrow_back" size={backButtonSize} />
          </button>
        ) : null}
        <h1 className={titleClassName}>{titleText}</h1>
      </div>
      <span
        className={styles.line}
        style={showBack ? { marginLeft: backButtonSize + 6 } : undefined}
        aria-hidden="true"
      />
    </div>
  );
};

export default DecoratedHeader;
